import CreateShopArticleTaxHistoryRequestModelBase from '../_generated/modelBases/create-shop-article-tax-history-request-model-base';

export default class CreateShopArticleTaxHistoryRequestModel extends CreateShopArticleTaxHistoryRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
